type RaffleStatusLike = string | null | undefined;

export function raffleStatusFromEngagement(
  engagement?: {
    type?: string | null;
    viewData?: { __typename?: string; raffleStatus?: RaffleStatusLike } | null;
  } | null,
): string | null {
  if (
    !engagement ||
    engagement.type !== 'RAFFLE' ||
    engagement.viewData?.__typename !== 'RaffleViewData'
  ) {
    return null;
  }
  return engagement.viewData.raffleStatus ?? null;
}

/** Mute scan-to-enter once entries are closed. */
export function shouldMuteRaffleJoinCta(status: RaffleStatusLike): boolean {
  return status === 'READY_TO_DRAW';
}

/** Hide the join QR during drawing and completed (frames have no QR). */
export function shouldHideRaffleJoinCta(status: RaffleStatusLike): boolean {
  return status === 'DRAWING' || status === 'COMPLETED';
}

export function raffleJoinBubbleText({
  status,
  engagementTitle,
}: {
  status: RaffleStatusLike;
  engagementTitle?: string | null;
}): string | null {
  if (status === 'READY_TO_DRAW') {
    return 'Drawing soon';
  }
  if (status === 'DRAWING' || status === 'COMPLETED') {
    return null;
  }
  return engagementTitle ?? '';
}
